var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineLesson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 50,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Additional Elements"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2038,
    height: 8695,
    transform: "translate(-120 -164)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Active Lesson"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Size=1920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "online-lesson",
    clipPath: "url(#clip0_53912_42999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.05322 36.6292V40.8534C1.05322 41.6634 1.87841 42.5657 2.68456 42.5657H49.647C50.4536 42.5657 50.9358 41.7335 50.9358 40.9229V36.6292H1.05322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.11053 37.6907V40.8534C2.11053 41.1087 2.49173 41.5042 2.68473 41.5042H49.6472C49.7143 41.5042 49.8787 41.2526 49.8787 40.9229V37.6907H2.11053ZM49.6472 43.6274H2.68473C1.30227 43.6274 -0.00390625 42.2797 -0.00390625 40.8534V35.5675H51.9931V40.9229C51.9931 42.2526 51.1156 43.6274 49.6472 43.6274Z",
    fill: "#2D3436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.4459 42.5993C20.3598 43.6492 20.5463 45.9848 20.3207 47.1265C20.1145 48.1712 19.9706 48.2063 19.4183 48.5141C19.1069 48.6855 18.581 48.9255 18.1401 49.1166L20.4459 42.5993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.5585 50.0912L17.7197 48.142C18.2446 47.9142 18.6775 47.7109 18.9086 47.5835L18.9804 47.5438C19.0464 47.5071 19.1035 47.4789 19.1516 47.4482C19.175 47.3877 19.2188 47.2449 19.2827 46.9201C19.3986 46.3351 19.3833 45.2023 19.371 44.292C19.3622 43.6142 19.3536 42.9745 19.3917 42.5117L21.4988 42.6862C21.4691 43.0472 21.477 43.6379 21.4856 44.2639C21.5003 45.3775 21.5157 46.5299 21.357 47.333C21.1071 48.6 20.7994 48.9616 20.0012 49.4032L19.9304 49.4425C19.5339 49.6611 18.9011 49.9425 18.5585 50.0912Z",
    fill: "#2D3436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.7953 49.124C33.3519 48.9297 32.8169 48.6866 32.5023 48.5141C31.9517 48.2063 31.8427 48.1712 31.6371 47.1265C31.4119 45.9848 31.5968 43.7066 31.5117 42.6566L33.7953 49.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.3727 50.0969C32.9451 49.9102 32.3583 49.6452 31.9946 49.4457L31.945 49.418C31.0807 48.936 30.8417 48.5656 30.5991 47.3325C30.4406 46.5283 30.4559 45.3939 30.4701 44.2967C30.4786 43.6831 30.4866 43.1035 30.4575 42.7425L32.5645 42.5705C32.6021 43.0313 32.5935 43.6598 32.5845 44.3254C32.5724 45.2204 32.5576 46.3346 32.6734 46.9201C32.7378 47.2492 32.7802 47.3999 32.8039 47.4678C32.851 47.4976 32.9066 47.5257 32.9716 47.5618C33.2385 47.7088 33.6678 47.9106 34.2165 48.1505L33.3727 50.0969Z",
    fill: "#2D3436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.771 50.0937H35.2228V47.9705H16.771V50.0937Z",
    fill: "#2D3436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M3.08868 5.99371H2.41469C1.66142 5.99371 1.04932 6.60943 1.04932 7.36522V36.6588H50.9202V7.36522C50.9202 6.60943 50.3066 5.99371 49.5538 5.99371H48.8957H3.08868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M51.977 37.7205H-0.00830078V7.36523C-0.00830078 6.02336 1.07851 4.93202 2.41421 4.93202H3.0882V7.05527H2.41421C2.24399 7.05527 2.10613 7.1943 2.10613 7.36523V35.5973H49.8626V7.36523C49.8626 7.1943 49.7235 7.05527 49.5533 7.05527H48.8952V4.93202H49.5533C50.8896 4.93202 51.977 6.02336 51.977 7.36523V37.7205Z",
    fill: "#2D3436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M4.94189 32.7765H47.014V2.95216H4.94189V32.7765Z",
    fill: "#55B1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M23.0629 1.15845H7.73096V29.7725H23.0629C24.7196 29.7725 26.0633 31.1213 26.0633 32.7844V4.1708C26.0633 2.50784 24.7196 1.15845 23.0629 1.15845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M8.78826 28.711H23.0629C23.7664 28.711 24.4283 28.892 25.0061 29.2093V4.17081C25.0061 3.09542 24.1344 2.22015 23.0629 2.22015H8.78826V28.711ZM27.1205 32.7844H25.0061C25.0061 31.709 24.1344 30.8342 23.0629 30.8342H6.67383V0.096756H23.0629C25.3001 0.096756 27.1205 1.92448 27.1205 4.17081V32.7844Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M29.1434 1.15845H44.4748V29.7725H29.1434C27.4872 29.7725 26.144 31.1213 26.144 32.7844V4.1708C26.144 2.50784 27.4872 1.15845 29.1434 1.15845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M29.1436 2.22015C28.0725 2.22015 27.2013 3.09542 27.2013 4.17081V29.2089C27.7787 28.892 28.4405 28.711 29.1436 28.711H43.4177V2.22015H29.1436ZM27.2013 32.7844H25.0869V4.17081C25.0869 1.92448 26.9069 0.096756 29.1436 0.096756H45.5321V30.8342H29.1436C28.0725 30.8342 27.2013 31.709 27.2013 32.7844Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M10.7808 6.67834H17.917V4.5551H10.7808V6.67834Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M10.7808 10.58H22.8003V8.45656H10.7808V10.58Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M10.7808 14.4193H22.8003V12.296H10.7808V14.4193Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M10.7808 18.2586H22.8003V16.1354H10.7808V18.2586Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M10.7808 22.0981H22.8003V19.9748H10.7808V22.0981Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M10.7808 25.937H22.8003V23.8137H10.7808V25.937Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M28.9526 10.58H40.9723V8.45656H28.9526V10.58Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M28.9526 14.4193H40.9723V12.296H28.9526V14.4193Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M28.9526 18.2586H40.9723V16.1354H28.9526V18.2586Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M28.9526 22.0981H40.9723V19.9748H28.9526V22.0981Z",
    fill: "#254B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M28.9526 25.937H40.9723V23.8137H28.9526V25.937Z",
    fill: "#254B77"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -19.5,
    width: 1837,
    height: 427,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53912_42999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineLesson);
export default __webpack_public_path__ + "static/media/online-lesson.4e153d2adac3505c1acae5c9eefca836.svg";
export { ForwardRef as ReactComponent };